module.exports = __webpack_public_path__ + "static/item-4-fdf5de3d48fd9563036ce3a5e83fa779.jpeg";